import React from "react";

const StockEditSubcategoryScreen = () => {
  return <div>StockEditSubcategoryScreen</div>;
};

export default StockEditSubcategoryScreen;
